
































































import _ from 'lodash';
import mixins from 'vue-typed-mixins';
import { editFactory } from '@/main/pages';
import { ShortcutMixin } from '@/main/mixins/shortcut';
import { MessageBoxCloseAction } from 'element-ui/types/message-box';

import { Column } from '@/main/utils/table';

import { createButton } from '@/main/utils/tableOperations';

import { showAlert } from '@/main/utils/notifications';

import { isUserPartsManager, OpenPartMaintenance } from '@/main/utils/commonFunctions';

import DmsPdfDialog from '#components/DmsPdfDialog.vue';

import {
	DEPENDENT_TABLES_ALL, NAME, PART_RETURN_STATUS, PART_RETURN_REASONS,
	NEW_COL_START_COUNT, PART_RETURN_REQ_DETAILS, ZAKAZKA_ND, PART_NUMBER_REF_COLUMN, PART_NUMBER_COLUMN, GRID_COLUMNS,
} from './constants';
import { store } from './store/edit/index';
import { apiProvider } from './api';
import { REPORT_TYPES } from '../constants';

export default mixins(editFactory(NAME, store), ShortcutMixin).extend({
	components: {
		DmsPdfDialog,
	},
	data() {
		return {
			dependencies: DEPENDENT_TABLES_ALL,
			apiProvider,
			visibleColumns: new Set(['ND_NR', 'TEXT', 'STAV', 'X_STAVVJ']),
			visiblepartReturnReqColumns: new Set([
				'PART_NO',
				'TEXT',
				'QUANTITY',
				'P_RETURN_QTY',
				'RETURN_REASON',
				'REQUESTED_BY',
				'REQUEST_STATUS',
				'COMMENTS',
			]),
			openPartReturn: false,
			newColumns: null as Column | null,
			tableRecordId: null as number | null,
			isOtherReason: false,
			zakazndColumnlegnth: 0,
			partReturnColumnlegnth: 0,
			checkSave: false,
			itemAlradySaved: false,
			reportType: null as string | null,
			showRejectDialog: false as boolean,
			multipleSelection: [],
			returnFullQuantity: false,
			gridCols: GRID_COLUMNS,
		};
	},
	computed: {
		isUserPartsManager(): boolean {
			return isUserPartsManager(this.pracovnik.PracovnikOzn, this.userRoles);
		},
		nahradniDilyTable(): any {
			if (this.isCreateMode) {
				_.forEach(this.dependentTables.ZakazkaNd.columns, col => {
					col.isVisible = this.visibleColumns.has(col.columnName);
				});
				this.zakazndColumnlegnth = NEW_COL_START_COUNT;
				const ReturnQtyl = this.zakazndColumnlegnth + 1;
				const ReturnReasonIdl = this.zakazndColumnlegnth + 2;
				const ReturnReasonl = this.zakazndColumnlegnth + 3;
				const OtherRemarksl = this.zakazndColumnlegnth + 4;
				this.newColumns = {
					columnName: 'RETURNQTY',
					isVisible: true,
					columnId: ReturnQtyl.toString(),
					propertyName: 'ReturnQty',
					valueType: 'Decimal',
				};
				this.dependentTables.ZakazkaNd.columns.push(this.newColumns);
				this.newColumns = {
					columnName: 'RETURNREASONID',
					isVisible: false,
					columnId: ReturnReasonIdl.toString(),
					propertyName: 'ReturnReasonId',
					valueType: 'Int32',
				};
				this.dependentTables.ZakazkaNd.columns.push(this.newColumns);
				this.newColumns = {
					columnName: 'RETURNREASON',
					isVisible: true,
					columnId: ReturnReasonl.toString(),
					propertyName: 'ReturnReason',
					valueType: 'String',
				};
				this.dependentTables.ZakazkaNd.columns.push(this.newColumns);
				this.newColumns = {
					columnName: 'OTHERREMARKS',
					isVisible: true,
					columnId: OtherRemarksl.toString(),
					propertyName: 'OtherRemarks',
					valueType: 'String',
				};
				this.dependentTables.ZakazkaNd.columns.push(this.newColumns);
				return this.dependentTables.ZakazkaNd;
			}
			return null;
		},
		partReturnReqDetailsTable(): any {
			if (this.isEditMode) {
				_.forEach(this.dependentTables.PartReturnReqDetails.columns, col => {
					col.isVisible = this.visiblepartReturnReqColumns.has(col.columnName);
				});
				let approveorRejected = false;
				_.forEach(this.dependentTables.PartReturnReqDetails.rows, col => {
					if (col.cells[this.dependentTables.PartReturnReqDetails.cellNames!.REQUEST_STATUS_ID] === PART_RETURN_STATUS.APPROVE
						|| col.cells[this.dependentTables.PartReturnReqDetails.cellNames!.REQUEST_STATUS_ID] === PART_RETURN_STATUS.REJECTED) {
						approveorRejected = true;
					}
				});
				if (!approveorRejected) {
					this.partReturnColumnlegnth = this.dependentTables.PartReturnReqDetails.columns.length;
					const SelectedStatusIdl = this.partReturnColumnlegnth + 1;
					const Statusl = this.partReturnColumnlegnth + 2;
					this.newColumns = {
						columnName: 'SELECTEDSTATUSID',
						isVisible: false,
						columnId: SelectedStatusIdl.toString(),
						propertyName: 'SelectedStatusId',
						valueType: 'Int32',
					};
					this.dependentTables.PartReturnReqDetails.columns.push(
						this.newColumns,
					);
					this.newColumns = {
						columnName: 'STATUS',
						isVisible: true,
						columnId: Statusl.toString(),
						propertyName: 'Status',
						valueType: 'String',
					};
					this.dependentTables.PartReturnReqDetails.columns.push(
						this.newColumns,
					);
				}
				return this.dependentTables.PartReturnReqDetails;
			}
			return null;
		},
		zakazkaTables(): any {
			const tables = [];
			if (this.isCreateMode) {
				tables.push(ZAKAZKA_ND);
			} else {
				tables.push(PART_RETURN_REQ_DETAILS);
			}
			return tables;
		},
		extraButtons(): {} {
			return { ...createButton(this.addPartReturnQty) };
		},
		extraButtonsReson(): {} {
			return { ...createButton(this.viewDetailsClick) };
		},
	},
	methods: {
		OpenPartMaintenance,
		onReturnFullQtyChange() {
			if (this.returnFullQuantity) {
				_.forEach(this.dependentTables.ZakazkaNd.rows, col => {
					if (col.cells[this.dependentTables.ZakazkaNd.cellNames!.ZAZNAM_ID] == this.tableRecordId) {
						this.ReturnQty = col.cells[this.dependentTables.ZakazkaNd.cellNames!.STAV];
					}
				});
			}
			return true;
		},
		printPartreturnRequest() {
			const column = this.dependentTables.PartReturnReqDetails.columns.find((item) => item.columnName === 'RETURN_REQUEST_ID');
			if (column !== undefined) {
				const { columnId } = column;
				const selectedRow = _(this.dependentTables.PartReturnReqDetails.rows).find((row) => row.cells[this.dependentTables.PartReturnReqDetails.cellNames!.RETURN_REQUEST_ID]);
				if (selectedRow !== undefined) {
					this.tiskDialog.filter = {
						OrderNumber: selectedRow.cells[Number(columnId)],
						IsCopy: false,
						IsView: false,
						ReportType: 'pdf',
					};
					this.reportType = REPORT_TYPES.PartReturnForm;
					this.tiskDialog.fetchPdfProvider = (filter: any) => apiProvider.getPartReturnServisReport(filter);
					this.tiskDialog.visible = true;
				}
			}
		},
		handleSelection(rows: []) {
			this.multipleSelection = rows;
		},
		async openApproveDialog() {
			const approveOrReject = 'PartsReturnApprove'
			const approveValidation = await this.partApproveRejectValidation(approveOrReject);
			if(approveValidation) return;
			 this.showConfirm({
				message: this.LocalizeChyboveHlasky('approvestatus'),
				title: this.LocalizeChyboveHlasky('questionTitle'),
				options: {
					cancelButtonText: this.Localize('Ne'),
					confirmButtonText: this.Localize('Ano'),
					callback: async (action: MessageBoxCloseAction) => {
						if (action === 'confirm') {
							this.RequestStatusId = PART_RETURN_STATUS.APPROVE;
							await this.saveClick();
						} else {
							return;
						}
					},
				},
			});
			
		},
		async openRejectDialog() {
			const approveOrReject = 'PartsReturnReject'
			const rejectValidation = await this.partApproveRejectValidation(approveOrReject);
			if(rejectValidation) return;
			this.showConfirm({
				message: this.LocalizeChyboveHlasky('rejectstatus'),
				title: this.LocalizeChyboveHlasky('questionTitle'),
				options: {
					cancelButtonText: this.Localize('Ne'),
					confirmButtonText: this.Localize('Ano'),
					callback: async (action: MessageBoxCloseAction) => {
						if (action === 'confirm') {
							this.RequestStatusId = PART_RETURN_STATUS.REJECTED;
							this.showRejectDialog = true;
						} else {
							return;
						}
					},
				},
			});
		},
		async partApproveRejectValidation(approveOrReject: string) {
			const idColumnIndex = this.partReturnReqDetailsTable!.cellNames!.idColumn;
			const selectedValues = this.multipleSelection.map((s: any) => [s.cells[idColumnIndex]]);
			if (selectedValues.length === 0) {
				showAlert({
					message: this.LocalizeChyboveHlasky(approveOrReject),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return true;
			}
			return false;
		},
		async loadData() {
			await this.default();
			await this.fetchTableSchemas(this.zakazkaTables);
			await this.fetchTableData(this.zakazkaTables);
			localStorage.removeItem('selectedValues');
		},
		async saveClick() {
			let checkquantiandreason = true;
			if (this.isCreateMode) {
				_.forEach(this.dependentTables.ZakazkaNd.rows, col => {
					if (col.cells[this.zakazndColumnlegnth + 2] === null) {
						showAlert({
							message: this.LocalizeChyboveHlasky('PlzSelectReasonForPartNo') + col.cells[PART_NUMBER_COLUMN],
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							options: {
								type: 'error',
							},
						});
						checkquantiandreason = false;
						return;
					}
					if (col.cells[this.zakazndColumnlegnth + 1] === null || col.cells[this.zakazndColumnlegnth + 1] <= 0) {
						showAlert({
							message: this.LocalizeChyboveHlasky('RetuQtyNotEmtyForPartNo') + col.cells[PART_NUMBER_COLUMN],
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							options: {
								type: 'error',
							},
						});
						checkquantiandreason = false;
					}
				});
				if (checkquantiandreason) {
					this.startLoading();
					if (!this.checkSave) {
						if (await this.createPartReturnRequest()) {
							this.checkSave = true;
							this.recomputeHash();
							this.refreshPreviousPage = true;
							this.closeClick();
						}
					} else {
						showAlert({
							message: this.LocalizeChyboveHlasky('ReturnReqHaBeenGen'),
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							options: {
								type: 'error',
							},
						});
					}
					this.endLoading();
				}
			} else {
				let CheckRequestStatus = true;
				_.forEach(this.dependentTables.PartReturnReqDetails.rows, col => {
					if (col.cells[this.dependentTables.PartReturnReqDetails.cellNames!.REQUEST_STATUS_ID]
						=== PART_RETURN_STATUS.APPROVE || col.cells[this.dependentTables.PartReturnReqDetails.cellNames!.REQUEST_STATUS_ID] === PART_RETURN_STATUS.REJECTED) {
						showAlert({
							message: this.LocalizeChyboveHlasky('ThisReqIsCompleted'),
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							options: {
								type: 'error',
							},
						});
						CheckRequestStatus = false;
						return;
					}
					if (col.cells[this.partReturnColumnlegnth + 1] === null) {
						showAlert({
							message: this.LocalizeChyboveHlasky('PlzSelectStatus'),
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							options: {
								type: 'error',
							},
						});
						CheckRequestStatus = false;
						return;
					}
					if (col.cells[this.partReturnColumnlegnth + 1] === PART_RETURN_STATUS.REJECTED && col.cells[this.partReturnColumnlegnth + 3] === null) {
						showAlert({
							message: this.LocalizeChyboveHlasky('PlzEnterReasonRejectItm'),
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							options: {
								type: 'error',
							},
						});

						CheckRequestStatus = false;
					}
				});
				if (CheckRequestStatus) {
					if (!this.checkSave) {
						this.startLoading();
						await this.approvePartReturnRequest();
						this.endLoading();
						this.recomputeHash();
						this.refreshPreviousPage = true;
						this.closeClick();
					}
				}
			}
		},
		rejectPartreturnReq() {
			if (this.RequestStatusId === PART_RETURN_STATUS.REJECTED) {
				this.isOtherReason = true;
			} else {
				this.isOtherReason = false;
				this.RejectedComments = '';
			}
			if (this.RequestStatusId !== null) {
				const index = this.RequestStatusId! - 1;
				this.Remarks = this.dropdownList.PartReqReturnStatus[index].Text;
			}
			_.forEach(this.dependentTables.PartReturnReqDetails.rows, col => {
				col.cells[this.partReturnColumnlegnth + 1] = this.RequestStatusId;
				col.cells[this.partReturnColumnlegnth + 2] = this.Remarks;
			});
		},
		saveRemarks() {
			_.forEach(this.dependentTables.PartReturnReqDetails.rows, col => {
				col.cells[this.partReturnColumnlegnth + 3] = this.RejectedComments;
			});
		},
		async approvePartReturnRequest() {
			let ApproveCount = 0;
			let RejectedCount = 0;
			let ReqId;
			const PReturnReqIdIndex = this.dependentTables.PartReturnReqDetails!.cellNames!.RETURN_REQUEST_ID;
			const IdIndex = this.dependentTables.PartReturnReqDetails!.cellNames!.ID;
			const PRecIdIndex = this.dependentTables.PartReturnReqDetails!.cellNames!.REC_ID;
			const PReturnQtyIndex = this.dependentTables.PartReturnReqDetails!.cellNames!.P_RETURN_QTY;
			const batchPartDetails = { 
				PartReturnOperations:	this.multipleSelection.map((col) => {
					const row = col as { cells: any[] };
					const PReturnReqId = row.cells[PReturnReqIdIndex];
					const Id = row.cells[IdIndex];
					const PRecId = row.cells[PRecIdIndex];
					const PReturnQty = row.cells[PReturnQtyIndex];
					const PartDetailsv = {
						PReturnReqId: PReturnReqId,
						Id: Id,
						UserId: this.pracovnik.PracovnikId,
						PRecId: PRecId,
						PReturnQty: PReturnQty,
						IsApproved: PART_RETURN_STATUS.APPROVE,
						RequestStatusId: this.RequestStatusId,
						Comments: this.RejectedComments,
					};
					if (PartDetailsv.RequestStatusId === PART_RETURN_STATUS.APPROVE) {
						ApproveCount += 1;
					}
					if (PartDetailsv.RequestStatusId === PART_RETURN_STATUS.REJECTED) {
						PartDetailsv.Comments = this.RejectedComments;
						RejectedCount += 1;
					}
					ReqId = PartDetailsv.PReturnReqId;
					return PartDetailsv;
				})
			};
			await apiProvider.approveReterurnRequest(batchPartDetails);
			if (this.dmsSys.SendMailNotificationPrp) {
				const NotificationObj = {
					SenderId: this.pracovnik.PracovnikId,
					ReceiverId: this.pracovnik.PracovnikId,
					NotificationMsg: this.LocalizeChyboveHlasky('PartReturnRequestApprove').replace('<REQ_ID>', `${ReqId}`)
						.replace('<ORDER_ID>', `${this.props.OrderId!}`).replace('<APPROVE_COUNT>', `${ApproveCount!}`)
						.replace('<REJECTED_COUNT>', `${RejectedCount!}`),
				};
				this.startLoading();
				if (ApproveCount > 0 || RejectedCount > 0) {
					await apiProvider.sendNotification(NotificationObj);
				}
				this.endLoading();
			}
		},
		async createPartReturnRequest() {
			let isDataSave = true;
			let partNo = "";
			const copy = _.cloneDeep(this.dependentTables.ZakazkaNd);
			_.forEach(copy.rows, col => {
				const PReturnQty = col.cells[this.zakazndColumnlegnth + 1]
				if (PReturnQty == undefined || PReturnQty == null || PReturnQty! <= 0) {
					isDataSave = false
					partNo = partNo + " " + col.cells[PART_NUMBER_COLUMN]
				}
			});
			if (isDataSave) {
				const postData = {
					OrderNo: this.OrderNo,
					RequestStatusId: PART_RETURN_STATUS.PENDING,
					Remarks: this.LocalizePopisostatni('PartReturnRequestRemarks'),
					RequestedFromId: this.pracovnik.PracovnikId,
				};
				this.startLoading();

				const { data: isLockedOrder } = await apiProvider.CheckPartReturnReqExists(postData);
				if (isLockedOrder) {
					showAlert({
					message: this.LocalizeChyboveHlasky('RETURN_REQUEST_PENDING'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return true;
				this.endLoading();
				}
				else{
				const { data: latestRequestId } = await apiProvider.insertData(postData);
				let ReqId = 0;
				const copy = _.cloneDeep(this.dependentTables.ZakazkaNd);
				_.forEach(copy.rows, col => {
					const PartDetailsv = {
						PReturnReqId: latestRequestId,
						PRecId: col.cells[this.dependentTables.ZakazkaNd.cellNames!.ZAZNAM_ID],
						PReturnQty: col.cells[this.zakazndColumnlegnth + 1],
						RequestStatusId: PART_RETURN_STATUS.PENDING,
						ReturnReasonId: col.cells[this.zakazndColumnlegnth + 2],
						Comments: col.cells[this.zakazndColumnlegnth + 4],
					};
					apiProvider.insertPartreturnReqDetails(PartDetailsv);
					ReqId = PartDetailsv.PReturnReqId;
				});
				const NotificationObj = {
					SenderId: this.pracovnik.PracovnikId,
					ReceiverId: this.pracovnik.PracovnikId,
					NotificationMsg: this.LocalizeChyboveHlasky('PartReturnReqSubmitted').replace('<REQ_ID>', `${ReqId!}`)
						.replace('<ORDER_ID>', `${this.OrderId!}`),
				};
				await apiProvider.sendNotification(NotificationObj);

				}
				
			} else {
				showAlert({
					message: this.LocalizeChyboveHlasky('RetuQtyNotEmtyForPartNo') + partNo,
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'error',
					},
				});
				return false;;
			}
			return true;
			this.endLoading();
		},
		async addPartReturnQty(e: any, cells: any) {
			this.openPartReturn = true;
			this.returnFullQuantity = false;
			const [zaznamRwids] = [cells[this.dependentTables.ZakazkaNd.cellNames!.ZAZNAM_ID]];
			this.tableRecordId = zaznamRwids;
			this.ReturnQty = null;
			this.ReturnReason = null;
			this.isOtherReason = false;
			this.OtherRemarks = null;
		},
		editPartReturnRequest() {
			if (this.isCreateMode) {
				if (this.ReturnQty! <= 0 || this.ReturnQty === null) {
					showAlert({
						message: this.LocalizeChyboveHlasky('ReturnQtyNotEmptyOrZero'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'error',
						},
					});
					return;
				}
				if (this.ReturnReason === null) {
					showAlert({
						message: this.LocalizeChyboveHlasky('ReturnReasonNotEmpty'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'error',
						},
					});
					return;
				}
				if (this.isOtherReason && _.isNil(this.OtherRemarks)) {
					showAlert({
						message: this.LocalizeChyboveHlasky('RemarkCompIfReasonOther'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'error',
						},
					});
					return;
				}
				_.forEach(this.dependentTables.ZakazkaNd.rows, col => {
					const qty = this.ReturnQty === null ? 0 : this.ReturnQty;
					if (col.cells[0] === this.tableRecordId) {
						if (col.cells[this.dependentTables.ZakazkaNd.cellNames!.STAV] >= qty) {
							col.cells[this.zakazndColumnlegnth + 1] = this.ReturnQty;
							col.cells[this.zakazndColumnlegnth + 2] = this.ReturnReason;
							col.cells[this.zakazndColumnlegnth + 3] = this.ReturnReasonText;
							col.cells[this.zakazndColumnlegnth + 4] = this.OtherRemarks;
						} else {
							showAlert({
								message: this.LocalizeChyboveHlasky('QtyNotGreaterThanAllotQty'),
								title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
								options: {
									type: 'error',
								},
							});
						}
					}
				});
			} else {
				if (this.RequestStatusId === PART_RETURN_STATUS.REJECTED && (this.RejectedComments === null || this.RejectedComments === '')) {
					showAlert({
						message: this.LocalizeChyboveHlasky('RemarkCompIfStatusReject'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'error',
						},
					});
					return;
				}
				_.forEach(this.dependentTables.PartReturnReqDetails.rows, (col: any) => {
					const matchesSelectedRow = this.multipleSelection.some((selectedRow: any) => selectedRow.cells[0] === col.cells[0]);
					if (matchesSelectedRow) {
						col.cells[this.partReturnColumnlegnth + 1] = this.RequestStatusId;
						col.cells[this.partReturnColumnlegnth + 2] = this.Remarks;
						col.cells[this.partReturnColumnlegnth + 3] = this.RejectedComments;
					}
				});
			}
			this.openPartReturn = false;
		},
		parReturnReqestCommentsUpdated() {
			if (this.RequestStatusId === PART_RETURN_STATUS.REJECTED) {
				this.isOtherReason = true;
			} else {
				this.isOtherReason = false;
			}
			if (this.RequestStatusId !== null) {
				if (this.RequestStatusId === PART_RETURN_STATUS.REJECTED) {
					this.Remarks = this.dropdownList.PartReqReturnStatus[1].Text;
				} else {
					this.Remarks = this.dropdownList.PartReqReturnStatus[0].Text;
				}
			}
		},
		onReasonUpdate() {
			if (this.ReturnReason !== null) {
				this.ReturnReasonText = _.find(this.dropdownList.ReturnReasons, (item) => item.Value === this.ReturnReason)?.Text!;
				this.isOtherReason = this.ReturnReasonText.trim() === PART_RETURN_REASONS.OTHER;
			}
		},
		viewDetailsClick(e: any, cells: any) {
			this.openPartReturn = true;
			this.returnFullQuantity = false;
			const [zaznamRwids] = [
				cells[this.dependentTables.PartReturnReqDetails.cellNames!.ID],
			];
			this.tableRecordId = zaznamRwids;
			this.Remarks = null;
			this.RejectedComments = null;
			this.RequestStatusId = null;
		},
		markReportAsPrint() {
			apiProvider.markReportAsPrint(this.OrderNo, this.reportType);
		},
	},
});
